import fetchService from '@/utils/model/fetch_service';
import logger from '@/utils/logger';
import globals from '@/globals';

// PRIVATE
function processItems(items, parentItem) {
  const { location } = globals.context;
  const currentPath = location.pathname + location.search;

  return items.map((menuItem) => {
    const item = { ...menuItem };
    if (item.values.uri === currentPath) {
      const parent = parentItem || item;
      parent.currentSubPage = item.values.label;
    }

    if (item.children) {
      processItems(item.children, item);
    }

    return item;
  });
}

function processResponse(data) {
  try {
    return processItems(data.nodes[0].children);
  } catch (err) {
    logger.warn(err);
    return [];
  }
}

// EXPORTED
function fetchLeftMenuSettings(context) {
  return fetchService.GetData('left_menu_settings', {})
    .then((response) => context.commit('replaceLeftMenuSettings', response));
}

function fetchLeftMenuData(context) {
  const { I } = globals;
  const group = I.settings.user.group_id;
  const stamp = I.settings.system.menu_ts;
  const path = `/${group}?${stamp}`;

  return fetchService.GetData('left_menu', { '@path': path })
    .then(processResponse)
    .then((response) => {
      context.commit('replaceLeftMenuItems', response);
      return response;
    });
}

function collapseMenu(context) {
  const { items } = context.state;

  if (Array.isArray(items)) {
    items.forEach((item, idx) => {
      items[idx].active = false;
    });
  }
}

export default {
  fetchLeftMenuData,
  fetchLeftMenuSettings,
  collapseMenu,
};
